import React from "react";
import PropTypes from "prop-types";
import DecisionModal from "./DecisionModal";

const DESCRIPTIONS = {
  first_session: "The first session has already started, so registration closes as soon as this class is published. Nobody will be able to register.",
  close_time: "The registration close time has already passed, so nobody will be able to register once this class is published.",
};

export default function ClosedRegistrationPublishModal({ reason, working = false, onConfirm, onClose }) {
  return (
    <DecisionModal
      type="warning"
      title="Registration is already closed"
      description={`${DESCRIPTIONS[reason]} You can publish anyway, or go back and change the dates.`}
      cancelLabel="Go Back"
      confirmLabel={working ? "Publishing…" : "Publish Anyway"}
      onConfirm={onConfirm}
      onClose={onClose}
      working={working}
    />
  );
}

ClosedRegistrationPublishModal.propTypes = {
  reason: PropTypes.oneOf(["first_session", "close_time"]).isRequired,
  working: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};
